import { Dict } from "./en";

/** Russian, formal address (Вы). */
export const ru: Dict = {
  "common.cancel": "Отмена",
  "common.save": "Сохранить",
  "common.send": "Отправить",
  "common.sending": "Отправка…",
  "common.next": "Далее",
  "common.change": "Изменить",
  "common.signIn": "Войти",
  "common.return": "Вернуться",
  "common.somethingWrong": "Что-то пошло не так, попробуйте ещё раз",

  "header.language": "Язык",
  "header.home": "Главная",
  "header.shop": "Магазин",
  "header.account": "Моя карта",
  "header.menu": "Меню",
  "header.support": "Поддержка",
  "header.profileSettings": "Настройки профиля",
  "header.blog": "Блог",
  "header.admin": "Админ",
  "header.signOut": "Выйти",

  "footer.copyright": "© {year} Touch Talk. Все права защищены",

  "home.createNfc": "Создайте свою NFC-карту",
  "home.createStyle": "Создайте свой стиль общения",
  "home.step1": "Изучите пакеты",
  "home.step2": "Создайте свою Talk-страницу",
  "home.step3": "Закажите карту и станьте доступнее для клиентов",
  "home.getStarted": "Начать",
  "home.partners": "Наши партнёры",
  "home.loginHint": "Если у Вас есть аккаунт, войдите",
  "home.reachTitle": "Одно касание — безграничный охват",
  "home.reachText": "Создайте цифровой профиль с контактами, ссылками на соцсети, портфолио и информацией о бизнесе. Делитесь им мгновенно — одним касанием.",

  "support.link": "Поддержка",
  "support.title": "Служба поддержки",
  "support.success": "Ваше сообщение успешно отправлено",
  "support.email": "Эл. почта*",
  "support.message": "Сообщение*",

  "order.title": "Оформить заказ",
  "order.package": "Пакет",
  "order.packageOption": "Пакет {title}",
  "order.name": "Имя*",
  "order.phone": "Номер телефона*",

  "shop.plans": "ТАРИФЫ",
  "shop.shops": "МАГАЗИН",
  "shop.blurb":
    "С одной подпиской Вы получаете больше, чем просто цифровую визитку: стильную NFC-карту, бесплатную замену и поддержку в течение всего года.",
  "shop.nfcCards": "NFC-карты",
  "shop.nfcStickers": "NFC-стикеры",
  "shop.petTag": "Жетон для питомца",
  "shop.mostPopular": "САМЫЙ ПОПУЛЯРНЫЙ",
  "shop.metalCard": "Металлическая карта",
  "shop.woodenCard": "Деревянная карта",
  "shop.emailLabel": "Адрес эл. почты",
  "shop.phoneLabel": "Номер телефона",
  "shop.invalidEmail": "Неверный адрес эл. почты",
  "shop.invalidPhone": "Неверный номер телефона",
  "shop.submitted": "Ваш заказ принят. Мы скоро свяжемся с Вами.",
  "shop.card": "Карта",
  "shop.sales": "Скидка",
  "shop.subscriptionFor": "Подписка на {period}",
  "shop.total": "Итого",
  "shop.order": "Заказать",
  "shop.addons": "Эксклюзивные дополнения",
  "shop.perMonth": "в месяц",
  "shop.getStarted": "Начать",
  "shop.addon.metalCard": "Металлическая карта",

  "plans.basic.title": "ВКЛЮЧАЕТ 1 ШТ.",
  "plans.basic.description": "визитка или стикер TOUCH TALK",
  "plans.pro.title": "ЖЕТОН ДЛЯ ПИТОМЦА",
  "plans.pro.description": "и функция страницы",
  "plans.period.1": "1 месяц",
  "plans.period.3": "3 месяца",
  "plans.period.6": "6 месяцев",
  "plans.period.12": "12 месяцев",
  "plans.option.socialNetworks": "Социальные сети",
  "plans.option.messengers": "Мессенджеры",
  "plans.option.url": "Ссылка (URL)",
  "plans.option.savingContacts": "Сохранение контактов",
  "plans.option.brandedCard": "Брендированная карта",
  "plans.option.customButtons": "Индивидуальный дизайн кнопок страницы",
  "plans.option.background": "Возможность сменить фон",
  "plans.option.map": "Карта",
  "plans.option.review": "Отзывы",
  "plans.option.swipe": "Слайдер фотографий на странице",
  "plans.option.replacement": "Бесплатная замена стандартной PVC-карты",
  "plans.option.petPage": "Страница для питомца",

  "blog.title": "Идеи для умных знакомств",
  "blog.all": "Все",
  "blog.tag": "Тег",
  "blog.clear": "сбросить",
  "blog.by": "автор:",
  "blog.noPosts": "Статей пока нет.",
  "blog.loadFailed": "Не удалось загрузить статьи.",
  "blog.back": "Назад в блог",
  "blog.notFound": "Статья не найдена.",
  "blog.sources": "Источники",
  "blog.published": "Опубликовано {date}.",
  "blog.accessed": "Дата обращения {date}.",

  "pages.plans.title": "Выберите подходящий тариф",
  "pages.plans.cta": "Сравнить тарифы в магазине",
  "pages.partners.title": "Нам доверяют команды и бизнес",
  "pages.contact.title": "Связаться с TouchTalk",
  "pages.contact.cta": "Написать в поддержку",
  "pages.privacy.title": "Политика конфиденциальности",
  "pages.privacy.pending": "Политика конфиденциальности готовится.",
  "pages.terms.title": "Условия использования",
  "pages.terms.pending": "Условия использования готовятся.",

  "auth.username": "Имя пользователя",
  "auth.password": "Пароль",
  "auth.forgot": "Забыли пароль?",
  "auth.accept": "Я принимаю",
  "auth.terms": "Условия использования",
  "auth.signingIn": "Вход…",
  "auth.errFields": "Введите имя пользователя и пароль",
  "auth.errWrong": "Неверное имя пользователя/эл. почта или пароль",
  "auth.errServer": "Сервер недоступен. Попробуйте ещё раз.",
  "auth.resetTitle": "Сброс пароля",
  "auth.createTitle": "Создание пароля",
  "auth.failed": "Не удалось",
  "auth.resetSubtitle": "Введите новый пароль",
  "auth.newPassword": "Новый пароль",
  "auth.confirmPassword": "Повторите пароль",
  "auth.confirm": "Подтвердить",
  "auth.mismatch": "Пароли не совпадают",
  "auth.findAccount": "Найти Ваш аккаунт",
  "auth.findHint": "Введите эл. почту или имя пользователя, и мы отправим ссылку для сброса пароля",
  "auth.success": "Готово",
  "auth.checkEmail": "Проверьте эл. почту",
  "auth.notFound": "К сожалению, аккаунт не найден. Обратитесь в поддержку.",
  "auth.emailOrUsername": "Эл. почта или имя пользователя",

  "settings.profile": "Данные профиля",
  "settings.picture": "Фото профиля",
  "settings.pictureTitle": "Фото профиля",
  "settings.name": "Имя",
  "settings.surname": "Фамилия",
  "settings.email": "Эл. почта",
  "settings.phone": "Номер телефона",
  "settings.updatePassword": "Изменить пароль",
  "settings.currentPassword": "Текущий пароль",
  "settings.newPassword": "Новый пароль",
  "settings.confirmPassword": "Повторите пароль",

  "profile.addToContacts": "Добавить в контакты",

  "validation.tooLong": "Не более {max} символов.",
  "validation.pattern": "Введите данные в указанном формате.",
  "validation.tooShort": "Не менее {min} символов.",
  "validation.required": "Это поле обязательно!",

  "cropper.title": "Обрезать изображение",
  "cropper.drag": "Перетащите, чтобы сдвинуть",
  "cropper.readError": "Не удалось прочитать изображение. Попробуйте другое.",
  "cropper.uploadError": "Не удалось загрузить. Попробуйте ещё раз.",
  "cropper.zoom": "Масштаб",
  "cropper.zoomIn": "Увеличить",
  "cropper.zoomOut": "Уменьшить",
  "cropper.uploading": "Загрузка…",

  "builder.saving": "Сохранение…",
  "builder.saved": "Сохранено",
  "builder.saveError": "Не удалось сохранить — проверьте соединение",

  "tour.skip": "Пропустить",
  "tour.back": "Назад",
  "tour.next": "Далее",
  "tour.done": "Готово",
  "tour.stepOf": "{n} из {total}",
  "tour.help": "Показать подсказки",
  "tour.s1.title": "Ваша карта",
  "tour.s1.text": "Это страница Вашей NFC-карты. Всё, что Вы добавите здесь, увидит тот, кто приложит телефон к карте.",
  "tour.s2.title": "Добавьте разделы",
  "tour.s2.text": "Нажмите «Добавить раздел», чтобы добавить профиль, ссылки, мессенджеры, фото или карту.",
  "tour.s3.title": "Редактирование и порядок",
  "tour.s3.text": "Нажмите на раздел, чтобы изменить его. Перетащите, чтобы поменять порядок, смахните влево, чтобы удалить.",
  "tour.s4.title": "Предпросмотр",
  "tour.s4.text": "Переключитесь в предпросмотр, чтобы увидеть страницу глазами посетителей.",
  "tour.s5.title": "Поделиться",
  "tour.s5.text": "В меню можно скопировать ссылку, скачать QR-код или переключить карту.",
  "form.show": "Показать",
  "form.hide": "Скрыть",
  "cropper.maxSide": "до {px}px",
  "builder.card": "Карта",
  "builder.addCard": "Добавить карту",
  "builder.adding": "Добавляем…",
  "builder.newCardName": "Новая карта",
  "builder.rename": "Переименовать «{name}»",
  "builder.saveName": "Сохранить название",
  "builder.copyLink": "Скопировать ссылку на карту",
  "builder.copied": "Скопировано",
  "footer.tagline": "NFC-визитки, которые всегда работают: делитесь контактами, ссылками и профилем одним касанием.",
  "footer.product": "Продукт",
  "footer.company": "Компания",
  "footer.shop": "Магазин",
  "footer.plans": "Тарифы",
  "footer.blog": "Блог",
  "footer.partners": "Партнёры",
  "footer.contact": "Контакты",
  "footer.privacy": "Политика конфиденциальности",
  "footer.terms": "Условия использования",
  // Hints, help guide and action tooltips (builder).
  "section.text.hint": "Короткое вступление, часы работы или предложение.",
  "section.link.hint": "Кнопка, которая открывает любой сайт, файл или форму записи.",
  "section.profile.hint": "Ваше фото, имя и должность — шапка карточки.",
  "section.messengers.hint": "WhatsApp, Telegram, Instagram и другие — посетители нажимают и связываются с Вами.",
  "section.swipe.hint": "Галерея фотографий; каждое фото может открывать свою ссылку.",
  "section.map.hint": "Ваше местоположение с маршрутом.",
  "hint.profile": "Загрузите квадратное фото, укажите имя и чем Вы занимаетесь. Это первое, что видят посетители.",
  "hint.text": "Пишите коротко — две-три строки читаются на телефоне лучше всего. Чтобы сделать слово ссылкой, выделите его и нажмите Link.",
  "hint.link": "Вставьте полный адрес (https://…). Дайте короткий заголовок — он станет текстом кнопки.",
  "hint.messengers": "Нажмите «Add new section», чтобы выбрать приложения, затем введите номер или ссылку на профиль. Посетитель нажимает иконку, и приложение открывается с Вашим чатом.",
  "hint.swipe": "Добавьте несколько фото. У каждого слайда может быть своя ссылка; оставьте пустым, чтобы использовать общую.",
  "hint.map": "Нажмите на карту, чтобы поставить метку, и введите адрес. Посетители получат маршрут одним касанием.",
  "hint.background": "Выберите цвет или загрузите фото. На тёмном фоне белый текст читается лучше.",
  "hint.external": "Используйте только если хотите, чтобы карточка открывала другой сайт вместо Вашего профиля.",
  "help.title": "Как это работает",
  "help.intro": "Короткие инструкции для самых частых задач. Нажмите на тему, чтобы раскрыть её.",
  "help.profile.title": "Создайте профиль",
  "help.profile.s1": "Нажмите «Add Section» внизу и выберите «Profile pic.».",
  "help.profile.s2": "Загрузите квадратное фото — в зависимости от стиля оно станет кругом или обложкой.",
  "help.profile.s3": "Введите имя и должность или компанию.",
  "help.profile.s4": "Нажмите «Save». Дальше изменения сохраняются автоматически.",
  "help.socials.title": "Добавьте соцсети и мессенджеры",
  "help.socials.s1": "Нажмите «Add Section» и выберите «Messengers».",
  "help.socials.s2": "Нажмите «Add new section», чтобы открыть каталог: WhatsApp, Telegram, Viber, Instagram, Facebook, LinkedIn, TikTok и другие.",
  "help.socials.s3": "Отметьте нужные приложения и нажмите «Save».",
  "help.socials.s4": "Под каждым приложением введите номер телефона (мессенджеры) или ссылку на профиль (соцсети).",
  "help.socials.s5": "На вкладке «Design» выберите иконки или кнопки и цвета. Затем «Save».",
  "help.links.title": "Добавьте ссылки и файлы",
  "help.links.s1": "Нажмите «Add Section» и выберите «Link».",
  "help.links.s2": "Введите короткий заголовок — он станет текстом кнопки — и вставьте полный адрес, начиная с https://.",
  "help.links.s3": "При желании загрузите иконку; на вкладке «Design» настраиваются цвета, скругления и тень.",
  "help.links.s4": "Нажмите «Save». Добавляйте сколько угодно ссылок: сайт, меню, прайс, форма записи, PDF.",
  "help.photos.title": "Добавьте фотографии",
  "help.photos.s1": "Нажмите «Add Section» и выберите «Swipe Photo».",
  "help.photos.s2": "Нажмите «Upload photo» и обрежьте каждое фото (у всех слайдов одна рамка 4:3).",
  "help.photos.s3": "Задайте слайду свою ссылку или укажите одну общую ссылку для всех.",
  "help.photos.s4": "Включите «Autoswipe», если хотите, чтобы галерея листалась сама. Затем «Save».",
  "help.map.title": "Добавьте местоположение",
  "help.map.s1": "Нажмите «Add Section» и выберите «Map».",
  "help.map.s2": "Нажмите на карту, чтобы поставить метку, и введите адрес и заголовок.",
  "help.map.s3": "Нажмите «Save». Посетители откроют маршрут одним касанием.",
  "help.background.title": "Смените фон",
  "help.background.s1": "Нажмите кнопку с карандашом внизу и выберите «Change profile background».",
  "help.background.s2": "Выберите цвет или загрузите фото (9:16 лучше всего смотрится на телефонах).",
  "help.background.s3": "Нажмите «Save». Цвет текста каждой секции настраивается на её вкладке «Design».",
  "help.cards.title": "Ваши карточки",
  "help.cards.s1": "Карточка — это одна публичная страница со своей ссылкой и QR-кодом. Каждая заказанная NFC-карта открывает одну из них.",
  "help.cards.s2": "Название вверху конструктора — текущая карточка. Нажмите на него, чтобы переключаться между карточками.",
  "help.cards.s3": "В этом списке нажмите «Add card», чтобы создать ещё одну — для второго бизнеса, сотрудника или мероприятия.",
  "help.cards.s4": "Нажмите карандаш рядом с карточкой, чтобы переименовать её.",
  "help.cards.s5": "Чтобы удалить карточку, откройте меню с карандашом внизу и выберите «Delete this card».",
  "help.share.title": "Поделитесь карточкой",
  "help.share.s1": "Нажмите иконку ссылки рядом с названием карточки, чтобы скопировать публичную ссылку.",
  "help.share.s2": "В меню с карандашом выберите «Show QR code», чтобы показать или скачать QR.",
  "help.share.s3": "С физической картой TouchTalk посетитель просто прикладывает телефон — приложение не нужно.",
  "help.share.s4": "Включите «Show contact saver» в меню с карандашом, чтобы посетители добавляли Вас в контакты одним касанием.",
  "help.order.title": "Закажите физическую карту",
  "help.order.s1": "Откройте магазин и выберите дизайн карты и тариф.",
  "help.order.s2": "Заполните форму заказа; мы свяжемся с Вами, чтобы подтвердить детали.",
  "help.order.s3": "Когда карта придёт, она уже будет открывать Ваш профиль — всё, что Вы собираете здесь, работает на ней.",
  "help.order.cta": "Перейти в магазин",
  "help.replayTour": "Повторить тур",
  "help.showHints": "Показать подсказки снова",
  "help.hintsReset": "Подсказки снова появятся",
  "tip.preview": "Посмотреть глазами посетителя",
  "tip.edit": "Вернуться к редактированию",
  "tip.menu": "Меню: QR-код, фон, удаление секций",
  "tip.drag": "Перетащите, чтобы изменить порядок",
  "tip.help": "Как это работает",
};
